/*
 * File: ui-sort.ts
 * File Created: 2023-12-20 01:18:39
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-06 01:57:06
 * Modified By: Val Liu
 * -----
 */

import { AnyHelper } from "@root/core";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "../core";

@UITag.set()
export class uiSort extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableHeaderCell];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true; /// default: true

    /// set prop sortable: true / false
    parse(input: IUITagInput): IUITagResult {
        /// default: true
        /// rule: true / false
        const rule = Boolean(this.parseRule(input) ?? true);

        return {
            props: {
                sortable: rule,
            },
        };
    }
}
